import React from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { isSafari } from 'common/utilities/utils';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';

/**
 *
 * @param {*} props - props for the start order item
 *
 */
const StartOrderItems = props => {
  const { contentData = {}, clickHandler = null } = props;
  const { buttonText = '', startOrderTitle = '', ariaLabel = '' } = contentData;
  const CustomStyledDiv = useStyleScripts(STYLE_SCRIPT_CONST?.START_ORDER_STYLES);

  return (
    CustomStyledDiv && (
      <CustomStyledDiv data-testid='start-order-items' className='headerBottom au' id='start-order-component'>
        <div className='headBottomParent'>
          <div className={`headBottomTxt${isSafari() ? ' start-order-text' : ''}`}>{startOrderTitle}</div>

          <ContainedButton
            variant={ButtonType.primary}
            className={'start-order-btn'}
            data-testid='start-order-button'
            aria-label={ariaLabel || buttonText}
            onClickHandler={clickHandler}
            id='startOrderItemButton'
          >
            <span>{buttonText}</span>
          </ContainedButton>
        </div>
      </CustomStyledDiv>
    )
  );
};
export default StartOrderItems;
